<template>
<div>
    <v-card>
      <v-toolbar dense class="toolbar" height="35px" color="grey lighten-3">     
        <img class="img-icons" src="@/assets/itinerary_details_icon.png" id="icon" alt="User Icon" />          
        <span >Itinerary Details </span>
        <v-spacer></v-spacer>
         <div class="md-toolbar-section-end">             
              <v-btn small style="margin-left:10px" @click="addFlight()" >
                    <img class="img-icons" src="@/assets/flight_icon.png"/>  ADD FLIGHT
              </v-btn>
        </div>
      </v-toolbar>
       <ag-grid-vue style="width: 100%;"
                 class="ag-theme-balham"
                 domLayout="autoHeight"
                 :columnDefs="columnDefs"
                 :enableFillHandle="true"
                 :defaultColDef="defaultColDef"
                 :frameworkComponents="frameworkComponents"
                 :context="context"
                 @cell-value-changed="gridDataChanged"
                 :rowData="flightData">
                </ag-grid-vue>
    </v-card>
    
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  // import moment from 'moment'
  import {AgGridVue} from "ag-grid-vue";
  import DeleteCell from "./DeleteCell.js";  
  import { mapState, mapActions } from 'vuex'
  import { EventBus } from './../../eventbus/event-bus.js';

  export default {
    name: 'itinerary-detail-panel',
    computed: {
        ...mapState('invoice', ['selectedInvoice','newInvoiceData']),
    },
    
    mixins: [validationMixin],  
    components: {
            AgGridVue,            
        },
    beforeMount() {
        this.context = { componentParent: this };
    },
    mounted() {
      let self=this;
      EventBus.$on('PrePrintAction', function () {        
        self.updateFlightData(JSON.parse(JSON.stringify(self.flightData)));
      });
    },
    data: () => ({
      invoice: {
        id: null,
        date: null,        
      },
      flightData:[],
      context: null,
      columnDefs:[
          { headerName: 'Airline', field:'airline'},
          { headerName: 'FLT Number', field:'flightNumber'},
          { headerName: 'FLT Class', field:'flightClass'},
          { headerName: 'Travel Date',field:'flightDate'},
          { headerName: 'Fly From', field:'flyFrom'},
          { headerName: 'Fly To', field:'flyTo'},
          { headerName: 'Depart Time', field:'departureTime'},
          { headerName: 'Air Time', field:'airTime'},
          { headerName: 'Status', field:'status'},          
          {
        headerName: "Action",
        field: "value",
        cellRenderer: "deleteCell",
        editable: false,
        colId: "deleteCell",
        width: 150
      },
        ], 
      frameworkComponents:{deleteCell:DeleteCell},
        menuItems:["sabre","gds"],
        defaultColDef: {
          flex: 1,
        editable: true
      },
      suppliers: [],
      gdsValues: []
    }),
    created () {
      // let self = this
    },
    watch: {
        selectedInvoice(newValue, oldValue) {
          if (newValue.flights) {
            console.log(oldValue)
            console.log(newValue)
            this.flightData = JSON.parse(JSON.stringify(newValue.flights))
          }
          else {
            this.flightData=[]
          }
        },
        newInvoiceData(newValue, oldValue) {
            console.log(oldValue)
            console.log(newValue)
            this.flightData = JSON.parse(JSON.stringify(newValue.flights))
        }
    },
    methods: {
      ...mapActions('invoice', ['updateFlightData']),        
        gridDataChanged()  {
          let cloneFlightData=JSON.parse(JSON.stringify(this.flightData))
          this.updateFlightData(cloneFlightData)
        },
       methodFromParent(rowIndex) {
           this.flightData.splice(rowIndex,1);
           this.gridDataChanged()
      },
        addFlight()  {
            this.flightData.push({airline:"",flightNumber:"",flightClass:"",flightDate:"",flyFrom:"", flyTo:"",
                departureTime:"", airTime:"",status:""});
        },
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }

</style>

<style scoped>
  .v-btn {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
</style>